<template>
    <div class="delivery-sec__body" v-if="this.$store.state.settings.site_id === 1">
        <RefundRu/>
    </div>
    <div class="delivery-sec__body" v-if="this.$store.state.settings.site_id === 2">
        <RefundEn/>
    </div>
</template>

<script>
import RefundRu from './ru/refund.vue'
import RefundEn from './en/refund.vue'
export default {
    components:{
        RefundRu,RefundEn
    },
    name: "refund"
}
</script>

<style scoped>

</style>
